// Third-party imports
import $ from 'jquery';

// Local imports
import { CART as CART_DATALAYER } from '../../datalayer/data/cart.js';
import * as event from '../../datalayer/event.js';
import * as currency from '../../util/currency.js';
import { push_data_object } from '../../datalayer/gtm/gtm_push.js';

// donation_type is an object that contains only the following attributes:
// * id
// * name
// * category
export function update_recommend_datalayer(
    donation_type,
    position,
    collection_title
) {
    CART_DATALAYER.impression_id.push(donation_type.id);
    CART_DATALAYER.impression_name.push(donation_type.name);
    CART_DATALAYER.impression_category.push(donation_type.category);

    // We're passing an empty value under the assumption that these products
    // are always donations, and they don't have variants
    CART_DATALAYER.impression_variant.push('');

    // We're adding blank prices, since donation addons don't have prices
    CART_DATALAYER.impression_price.push('');

    CART_DATALAYER.impression_list_name.push(collection_title);
    CART_DATALAYER.impression_position.push(position);
}

// item is an object that contains only the following attributes:
// * id
// * title
// * price
// * quantity
// * variant_sku
// * variant_id
// * url
// * category
// * type
export function update_item_datalayer(
    item,
    position,
    category,
    age,
    country,
    gender,
    collection_title
) {
    CART_DATALAYER.age.push(age);
    CART_DATALAYER.category.push(category);
    CART_DATALAYER.country.push(country);
    CART_DATALAYER.gender.push(gender);
    CART_DATALAYER.id.push(item.id);
    CART_DATALAYER.list_name.push(collection_title);
    CART_DATALAYER.list_position.push(position);
    CART_DATALAYER.name.push(item.title);
    CART_DATALAYER.price.push(item.price);
    CART_DATALAYER.quantity.push(item.quantity);
    CART_DATALAYER.sku.push(item.variant_sku);
    CART_DATALAYER.url.push(item.url);
    CART_DATALAYER.variant.push(item.variant_id);
    CART_DATALAYER.type.push(item.type);
}

// --------------------------------------------------------------------------
// Update cart datalayer
// --------------------------------------------------------------------------

// global arg is expected to be the window object when run in a browser
function update_price_array(global) {
    let matches = global.document.querySelectorAll('.basketCard-total');
    for (let [i, el] of matches.entries()) {
        let html = el.innerHTML;
        let price = html.split(':')[1];
        price = currency.clean(price).toString();
        CART_DATALAYER.price[i] = price;
    }
}

function card_data_country(shared, index, el) {
    let country =
        $(el).attr('data-country') !== null ? $(el).attr('data-country') : ' ';
    if (
        shared.categoryName.toLowerCase() ===
        $(el)
            .attr('data-js-type')
            .toLowerCase()
            .trim()
    ) {
        CART_DATALAYER.category[index] = `Sponsorship/${country}`;
    } else {
        CART_DATALAYER.category[index] = `non-sponsorship/${country}`;
    }
}

function card_data_sg(shared, index, el) {
    if (
        shared.singleGift.toLowerCase() ===
        $(el)
            .attr('data-frequency')
            .toLowerCase()
    ) {
        CART_DATALAYER.brand[index] = 'One Time Donation';
    } else if (
        $(el)
            .attr('data-frequency')
            .toLowerCase() === ''
    ) {
        CART_DATALAYER.brand[index] = 'One Time Donation';
    } else {
        CART_DATALAYER.brand[index] = 'Pledge';
    }
}

function card_data_notype(shared, index, el) {
    //TEST condition for GC items which don't have "data-type" attr
    let datatype = $(el).attr('data-type');
    if (typeof datatype === 'undefined' || datatype === null) {
        CART_DATALAYER.list_name[index] = 'gift catalogue';

        //added product category for default
        CART_DATALAYER.category[index] = 'Gift Catalogue';
        shared.productName = CART_DATALAYER.name[index];
    } else if (
        shared.arrayListName.toLowerCase() ===
        $(el)
            .attr('data-type')
            .toLowerCase()
    ) {
        CART_DATALAYER.list_name[index] = 'sponsorship';
        shared.productName = 'Child Sponsorship';
    } else {
        CART_DATALAYER.list_name[index] = 'donations';
        shared.productName = CART_DATALAYER.name[index];
    }
}

function card_data_type(shared, index, el) {
    let product_type = $(el).attr('data-producttype');
    if (
        typeof product_type !== 'undefined' &&
        shared.productType === product_type.trim()
    ) {
        CART_DATALAYER.type[index] = 'addon';
    } else {
        CART_DATALAYER.type[index] = 'regular';
    }

    let product_set =
        `${CART_DATALAYER.category[index]}^` +
        `${CART_DATALAYER.brand[index]}^` +
        `${shared.productName}`;
    CART_DATALAYER.set.push(product_set);
}

// global arg is expected to be the window object when run in a browser
function update_card_data(global) {
    let shared = {
        singleGift: 'sg',
        arrayListName: 'SP',
        categoryName: 'Child Sponsorship',
        productType: 'addon',
        productName: '',
        country: '',
    };

    let matches = global.document.querySelectorAll('.basketCard--itemCard');
    let funclist = [
        card_data_country,
        card_data_sg,
        card_data_notype,
        card_data_type,
    ];
    for (let [i, el] of matches.entries()) {
        for (let func of funclist) {
            func(shared, i, el);
        }
    }
}

// global arg is expected to be the window object when run in a browser
export function update_cart_datalayer(global) {
    update_price_array(global);
    update_card_data(global);
}

// --------------------------------------------------------------------------
// Update datalayer when going to checkout
// --------------------------------------------------------------------------

export function update_cart_tocheckout_datalayer(global) {
    let utag_data = global.utag_data;
    let sie_input = global.document.querySelector('#hidden_sie');
    let sie_flag = 'no';
    if (sie_input === null) {
        sie_input = global.document.querySelector('#sie_flag');
        if (sie_input !== null) {
            sie_flag = sie_input.attributes['value'].value;
        }
    }

    utag_data['event_category'] = 'Ecommerce';
    utag_data['event_action'] = 'Checkout Step 1 Success';
    utag_data['enh_checkout_step'] = 1;
    let option = 'Do not send letter of introduction';
    if (sie_flag === 'yes') {
        option = 'Send letter of introduction';
    }
    utag_data['enh_option'] = option;

    event.dispatch(global, event.EventKind.ToCheckout);
}

// --------------------------------------------------------------------------
// Update datalayer when item removed from cart
// --------------------------------------------------------------------------
export function update_cart_remove_datalayer(global, cart_item) {
    let utag_data = global.utag_data;
    let item_data = cart_item.dataset;

    utag_data['event_category'] = 'Ecommerce';
    utag_data['event_action'] = 'Remove from Cart';
    utag_data['event_label'] = 'Removed From Cart';

    utag_data['product_price'] = item_data.dataPrice;
    utag_data['product_id'] = item_data.productId;
    utag_data['product_name'] = item_data.name;
    utag_data['product_brand'] = item_data.brand;
    utag_data['product_variant'] = item_data.variant;
    utag_data['product_category'] = item_data.category;
    utag_data['product_quantity'] = item_data.quantity;
    utag_data['product_list'] = item_data.productList;
    utag_data['product_position'] = item_data.productPosition;
    utag_data['product_age'] = item_data.age;
    utag_data['product_gender'] = item_data.gender;
    utag_data['product_country'] = item_data.country;

    //== gtm-push: remove product from cart ==//
    let data_object = {
        event: 'remove_from_cart',
        ecommerce: {
            remove: {
                products: [
                    {
                        item_name: item_data.name,
                        item_id: item_data.productid,
                        price: item_data.price,
                        item_brand: item_data.brand,
                        item_category: item_data.category,
                        item_variant: item_data.variant,
                        item_list_name: item_data.productlist,
                        quantity: item_data.quantity,
                    },
                ],
            },
        },
    };
    push_data_object(data_object);

    event.dispatch(global, event.EventKind.RemoveFromCart);
}

export function update_cart_zeroquantity_datalayer(global, button) {
    let wrapper = button.closest('.js-quantityIncrementer-componentWrapper');
    let counter = wrapper.querySelector('.js-quantityIncrementer-counter');

    // Get the value of the counter (pre change)
    let counter_val = parseInt(counter.attributes.value.value);

    // This is called when the decrease quantity button is pressed. If the
    // counter value was at 1, then it's now at 0 and is being removed
    if (counter_val === 1) {
        update_cart_remove_datalayer(global, wrapper);
    }
}

// --------------------------------------------------------------------------
// Update datalayer when recommended item added to cart
// --------------------------------------------------------------------------

// TODO: the cart page has a form for every item in the cart, but this
// function adds a parsley handler only for the addon donation form. Should this
// try and detect which form is being submitted?
export function update_cart_addon_datalayer(global) {
    let utag_data = global.utag_data;

    global.Parsley.on('form:success', formobj => {
        validate_good(global, utag_data, formobj);
    });
    global.Parsley.on('form:error', formobj => {
        validate_bad(global, utag_data, formobj);
    });
}

function validate_good(global, utag_data, formobj) {
    let cardnum = formobj.$element[0].dataset.cardnum;

    // If cardnum is undefined, this is because this is a cart item, and not
    // an addon item card.
    if (typeof cardnum !== 'undefined') {
        addon_cartadd(global, utag_data, true, cardnum);
    }
}

function validate_bad(global, utag_data, formobj) {
    let cardnum = formobj.$element[0].dataset.cardnum;

    // If cardnum is undefined, this is because this is a cart item, and not
    // an addon item card.
    if (typeof cardnum !== 'undefined') {
        addon_cartadd(global, utag_data, false, cardnum);
    }
}

function addon_data(global, cardnum) {
    let input = global.document.querySelector(`#addonInputValue_${cardnum}`);
    let price = input.value;

    let input_data = input.dataset;
    let freq_id = `#id-${input_data.productvariant}-paymentFrequency`;
    let el = global.document.querySelector(`${freq_id}`);
    let freq_el = el.options[el.selectedIndex];
    let freq = freq_el.value;

    let ret = {
        input,
        price,
        freq,
    };

    return ret;
}

function update_addon_datalayer(utag_data, input_data, price, freq) {
    utag_data['product_price'] = price;
    utag_data['product_id'] = input_data.productid;
    utag_data['product_name'] = input_data.productname;
    utag_data['product_brand'] = freq;
    utag_data['product_variant'] = input_data.productvariant;
    utag_data['product_category'] = input_data.productcategory;
    utag_data['product_quantity'] = input_data.productquantity;
}

function addon_cartadd(global, utag_data, success, cardnum) {
    let { input, price, freq } = addon_data(global, cardnum);
    let input_data = input.dataset;

    let event_cat;
    let ea_val;
    let ea_label;
    if (success === true) {
        ea_val = 'Add to Cart';
        ea_label = 'Cart Addon, Add To Cart Success';
        event_cat = event.EventKind.AddToCart;

        addon_gtm_push(cardnum, price, freq, input_data, 'add_to_cart', 'add');
    } else {
        ea_val = 'Add to Cart - Errors';
        ea_label = 'Cart Addon, Add To Cart Error';
        event_cat = event.EventKind.AddToCartError;
    }

    utag_data['event_category'] = 'Ecommerce';
    utag_data['event_action'] = ea_val;
    utag_data['event_label'] = ea_label;

    update_addon_datalayer(utag_data, input_data, price, freq);

    event.dispatch(global, event_cat);
}

// --------------------------------------------------------------------------
// Update datalayer when recommended item clicked
// --------------------------------------------------------------------------

export function update_cart_addonclick_datalayer(global) {
    for (let i = 1; i < 5; i++) {
        let id = `#addonCardClickId_${i}`;
        let el = global.document.querySelector(id);

        if (el === null) {
            continue;
        }

        el.addEventListener('click', () => {
            onclick_addon(global, el);
        });
    }
}

function onclick_addon(global, element) {
    let utag_data = global.utag_data;

    let cardnum = element.dataset.cardnum;
    let { input, price, freq } = addon_data(global, cardnum);
    let input_data = input.dataset;

    utag_data['event_category'] = 'Ecommerce';
    utag_data['event_action'] = 'Product Click';
    utag_data['event_label'] = 'Cart Addon Clicked';

    update_addon_datalayer(utag_data, input_data, price, freq);

    utag_data['product_list'] = 'Cart Addon List';
    utag_data['product_position'] = input_data.productposition;
    utag_data['enh_action'] = 'click';

    event.dispatch(global, event.EventKind.ProductClick);

    addon_gtm_push(cardnum, price, freq, input_data, 'select_item', 'click');
}

function addon_gtm_push(
    cardnum,
    price,
    freq,
    input_data,
    eventType,
    actionType
) {
    let brand = freq === 'SG' ? 'One Time Donation' : 'Pledge';
    let data_object = {
        event: eventType,
        ecommerce: {},
    };
    data_object.ecommerce[actionType] = {
        items: [
            {
                item_name: input_data.productname,
                item_id: input_data.productid,
                price: price,
                item_brand: brand,
                item_category: input_data.productcategory,
                index: cardnum,
            },
        ],
    };
    push_data_object(data_object);
}
